<template>
    <div
        class="form-group"
        :class="[
            {
                'form-row': horizontal,
            },
        ]"
    >
        <label
            v-if="label"
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? class_label : '',
                size == 'sm' ? 'col-form-label-sm' : '',
            ]"
        >
            {{ label }}
        </label>
        <div
            :class="[
                horizontal ? class_input : '',
                size == 'sm' ? 'input-group-sm' : '',
            ]"
        >
            <input
                v-model="
                    valueComponent
                "
                :min="min"
                :max="max"
                :step="step"
                type="range"
                :class="['w-100']"
                :horizontal="inputHorizontal"
            />
            <div v-if="isValid == false" class="invalid-feedback">
                {{ invalidFeedback }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CCRange",
    data() {
        return {
            optionsComponent: [],
            checkedComponent: this.value,
            valueComponent: null,
            class_label: "col-sm-3",
            class_input: "col-sm-9",
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        value:{
            default:null
        },
        name: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "primary",
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        checked: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        size: {
            default: undefined,
        },
        invalidFeedback: {
            default: undefined,
        },
        disabled: {
            default: false,
        },

        min: {
            default: 0,
        },
        max: {
            default: 100,
        },
        step: {
            default: 1,
        },
    },
    watch: {
        valueComponent(newValue) {
            this.$emit("update:value", newValue);
            this.$emit("value", newValue);
        },
        value(newValue) {
            this.valueComponent = newValue;
        },
    },
    methods: {
        setHorizontalClass: function () {
            if (this.horizontal.label) {
                this.class_label = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.class_input = this.horizontal.input;
            }
        },
    },
    async mounted() {
        this.setHorizontalClass();
        this.valueComponent = this.value;
    },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";
.ui.dropdown {
    & .icon {
        background: transparent !important;
    }
}
.ui.selection.dropdown {
    & .text.default {
        color: #6c757d;
    }
}
.ui.selection.dropdown.is-invalid {
    @extend .is-invalid;
    & .icon {
        opacity: 0;
    }
}
.ui.selection.dropdown.is-valid {
    @extend .is-valid;
    & .icon {
        opacity: 0;
    }
}

.input-group-sm {
    & .ui.search.dropdown {
        & .text {
            top: -0.2em;
        }
    }
}

.search-select-wrapper {
    position: relative;
    & .btn-reset {
        position: absolute;
        right: 1%;
        top: 0;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(0.75em + 0.475rem);
        & .btn-reset__icon {
            background-color: white;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
